import { Injectable } from '@angular/core';
import { AuthentService } from 'src/app/Services/authent.service';
import { CommonService } from 'src/app/Services/common.service';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  constructor(
    private commonService: CommonService,
    private authentService: AuthentService,
  ) { }

  getGipServicesUrl() {
    return this.commonService.getGipServicesUrl();
  }

  async getNonOData(urls: string[], CallbackFunction) {
    this.authentService.getToken().then(async token => {
      const responses = await Promise.all(urls.map(url => fetch(this.getGipServicesUrl() + url, {
        headers: {
          "Authorization" : `Bearer ${token}`
        }
      })));

      const results = new Array();

      for (const res of responses) {
        if(res.status === 401 && localStorage.getItem("access_token") != null){
          var getRefreshToken = await this.authentService.getRefreshToken();
          this.getNonOData(urls, CallbackFunction);
        }
        const data = await res.json();
        results.push(data);
      }

      CallbackFunction(results);
    })
  }
}
